import React, {useContext} from 'react';
import {sideMenuContext} from "../../../router/IndexRouter";
import {DateTimeToMoment} from "./MomentDateTimeConverter";
import OnFinishMethod from "./OnFinishMethod";


const EditFormComponent = ({UserForm, url}) => {
    const currentUrl = window.location.href;
    const {currentItem} = useContext(sideMenuContext);
    // 将 currentItem 中属于 DateTime 类型的元素转成 Moment 类型，实现在页面的 DatePicker 组件中显示
    const newCurrentItem = Object.keys(currentItem).length > 0 ? DateTimeToMoment(currentItem) : {};

    // 编辑完表单中的数据后执行 onFinish 方法，此时的 data 为编辑完的 Object 对象
    const onFinish = (data) => {
        // 当用于新增参会人员时，需要提供 meetingId
        const regex = /\/meeting-notice\/(\d+)/; // 正则表达式
        const match = currentUrl.match(regex); // 使用 match() 方法匹配正则表达式
        let addIdData = {};
        // 由于编辑完的表单数据 data 中没有 id 信息，因此需要使用 ...currentItem 保留 id 信息，这样才能重新写入数据库
        if (match) {
            const meetingId = match[1]; // ['/meeting-notice/10003', '10003']， 提取第一个括号中的匹配结果
            addIdData = {...currentItem, ...data, meetingId: meetingId};
        } else {
            addIdData = {...currentItem, ...data};
        }
        // console.log("addIdData    ", addIdData)
        OnFinishMethod(addIdData, url);
    }

    return (
        <UserForm onFinish={onFinish} initialValues={newCurrentItem}/>
    )
};

export default EditFormComponent;
